export const columnSchema = [
  { width: 34, field: 'name', displayName: 'Name', type: 'string' },
  { width: 95, field: 'importedBy', displayName: 'Created By', type: 'string' },
  { width: 120, field: 'createdOn', displayName: 'Imported On', type: 'datetime' },
  { width: 65, field: 'importCount', displayName: 'Opportunities', type: 'number' },
  { width: 70, field: 'id', displayName: 'Import ID', type: 'number', sortIndex: 0, sortOrder: 'desc' },
  { width: 120, field: 'completedOn', displayName: 'Completed On', type: 'datetime' },
  { width: 120, field: 'failedOn', displayName: 'Failed On', type: 'datetime' },
];